export function isDesktopView() {
  return window.innerWidth >= 1280;
}

export const debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const isIos = () => {
  if (typeof window === `undefined` || typeof navigator === `undefined`)
    return false;

  return /iPhone|iPad|iPod/i.test(
    navigator.userAgent ||
      navigator.vendor ||
      (window.opera && opera.toString() === `[object Opera]`)
  );
};

export const getPhoneNumber = () => {
  const phone = "020-82 82 82";
  const phoneFull = phone
    .replaceAll("020", "+4620")
    .replaceAll(" ", "")
    .replaceAll("-", "");
  return [
    phone,
    phoneFull,
    () => {
      if (window.__ctm) {
        window.__ctm.main.runNow();
      }
    },
  ];
};

export function scrollStartStop(callbackStart, callbackStop, refresh = 66) {
  if (!callbackStart || typeof callbackStart !== "function") return;
  if (!callbackStop || typeof callbackStop !== "function") return;

  // Setup scrolling variable
  let isScrolling;
  let scrollStarted = false;

  // Listen for scroll events
  window.addEventListener(
    "scroll",
    function (event) {
      if (scrollStarted === false) {
        callbackStart();
        scrollStarted = true;
      }

      // Clear our timeout throughout the scroll
      window.clearTimeout(isScrolling);

      // Set a timeout to run after scrolling ends
      isScrolling = setTimeout(() => {
        scrollStarted = false;
        callbackStop();
      }, refresh);
    },
    false
  );
}
